// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3n_HS","footerContainer":"Footer_footerContainer__3FFVK"};